<template>
  <div class="row">
    <span v-for="(email, index) in list" :key="'email'+index" class="col-12">
      <text-input :name="'email'+index" type="email" :required="false"
                  v-model="list[index]" :placeholder="getPlaceholder"
      />
    </span>

    <span class="add-btn">
      <button ref="btn" class="btn" id="add-tooltip" @click="$emit('add')">
        <fa fa-class="plus" />
      </button>

      <b-tooltip target="add-tooltip">
        {{$t('_add')}}
      </b-tooltip>
    </span>
  </div>
</template>

<script>
import textInput from '@/components/frontoffice/form/baseInput/text'
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    textInput,
    fa
  },

  props: {
    value: Array,
    placeholder: String
  },

  data () {
    return {
      list: this.value
    }
  },

  computed: {
    getPlaceholder () {
      return this.placeholder || '_enter_email_copie'
    }
  }
}
</script>
